/* eslint-disable import/prefer-default-export */
export const NumChangeType = {
    INC: 'increase',
    DESC: 'descrease',
};

export const NumRange = {
    MULTI_MAX: 132, // 单位为倍
    MULTI_MIN: 0.25,
    POUND_MAX: 1500, // 单位为磅
    POUND_MIN: 0.7,
};

export const isPoundGap = 1;
export const isMultiGap = 0.25;

export const MAX_CM = 142.24;
export const MIN_CM = 0;
export const MAX_PT = 1584;
export const MIN_PT = 0;
export const MAX_MULTIPLE = 9.9;
export const MIN_TABSTOP_CM = 0.16;

export const STEP_PT = 6;
export const STEP_CM = 0.1;
export const STEP_MULTIPLE = 0.25;
